import UserLayout from './userLayout';

export default UserLayout;